import { action } from '../../../lib/api.js';

const clearFilters = () => {
  action('uiPatchFilters', { search: '', statusId: '', companyConnectionId: '', jobSchedule: '' });
  action('uiClearSearch');
};

export default clearFilters;
